import { GetterTree } from "vuex";
import { TeamsState, TeamState, TeamStudentState } from "./state";
import { orderBy } from "lodash";
import { defineVuexName, MODULES } from "../utils";

const getters: GetterTree<TeamsState, any> = {
  //teams
  [defineVuexName(MODULES.TEAMS.GETTERS.GET_TEAMS)](state: TeamsState): TeamState[] {
    return orderBy(state.teams, ["order"], ["asc"]);
  },
  //allStudents
  [defineVuexName(MODULES.TEAMS.GETTERS.GET_ALL_STUDENTS)](state: TeamsState): TeamStudentState[] {
    return state.allStudents;
  },
  //isTeamMode
  [defineVuexName(MODULES.TEAMS.GETTERS.GET_IS_TEAM_MODE)](state: TeamsState): boolean {
    return state.isTeamMode;
  },
  //isLoading
  [defineVuexName(MODULES.TEAMS.GETTERS.GET_IS_LOADING)](state: TeamsState): boolean {
    return state.isLoading;
  },
  //findAvatarUrlById
  [defineVuexName(MODULES.TEAMS.GETTERS.GET_AVATAR_URL_BY_ID)]: (state: TeamsState): ((id: string) => undefined | string) => {
    return (id: string) => state.allStudents.find((student) => student.id === id)?.avatarUrl;
  },
  //settingModalOpened
  [defineVuexName(MODULES.TEAMS.GETTERS.GET_IS_SETTING_MODAL_OPEN)](state: TeamsState): boolean {
    return state.settingModalOpened;
  },
  //enableTeamModeOnSave
  [defineVuexName(MODULES.TEAMS.GETTERS.GET_IS_ENABLE_TEAM_MODE_ON_SAVE)](state: TeamsState): boolean {
    return state.enableTeamModeOnSave;
  },
  //teamsRevision
  [defineVuexName(MODULES.TEAMS.GETTERS.GET_TEAMS_REVISION)](state: TeamsState): number {
    return state.revision;
  },
};

export default getters;
